module.exports = __webpack_public_path__ + "static/privileged-overview-91b840b11cf128504134a9e3f67db4c3.png";